<template>
  <section class="min-h-screen bg-black text-white font-sans">
    <div class="max-w-7xl mx-auto px-6 py-20 space-y-5 md:space-y-10">
      <!-- Hero Section -->
      <div class="text-center space-y-5 md:space-y-10 -mt-8">
        <h1 class="text-3xl md:text-6xl text-[#e6204b] font-semibold ">
          {{ $t('eventTitle') }}
        </h1>
        <p class="text-sm md:text-2xl  text-gray-400 max-w-3xl mx-auto">
          {{ $t('eventSubtitle') }}
        </p>
      </div>

      <!-- Description -->
      <div class="text-center mx-auto w-11/12 md:w-9/12">
        <p class=" tracking-wide text-gray-500 text-sm">
          {{ $t('gallery') }}
        </p>
      </div>

      <!-- Gallery Section -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mb-20">
        <div v-for="(photo, i) in photos" :key="i"
          class="overflow-hidden rounded-3xl shadow-xl hover:scale-105 transform transition duration-300 ease-in-out">
          <img :src="photo" alt="event" class="w-full h-72 object-cover object-center" />
        </div>
      </div>



      <!-- Call to Action -->
      <div class="text-center">
        <router-link to="/tickets"
          class="inline-block px-6 md:px-10 py-2 md:py-4 bg-white text-black rounded-full text-sm md:text-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg">
          {{ $t('reservermaintenant') }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      photos: [
        '/images/gallerie/photo1.jpg',
        '/images/gallerie/photo2.jpg',
        '/images/gallerie/photo3.jpg',
        '/images/gallerie/photo4.jpg',
        '/images/gallerie/photo5.jpg',
        '/images/gallerie/photo6.jpg',
        '/images/gallerie/photo7.jpg',
        '/images/gallerie/photo8.jpg',
        '/images/gallerie/photo9.jpg',
        '/images/gallerie/photo10.jpg',
        '/images/gallerie/photo11.jpg',
      ],
    };
  },
};
</script>

<style>
body {
  -webkit-font-smoothing: antialiased;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}
</style>
